import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const LibraryPage = lazy(() =>
  import('./pages/LibraryPage').then(m => ({ default: m.LibraryPage }))
);
const LibraryItemPage = lazy(() =>
  import('./pages/LibraryItemPage').then(m => ({ default: m.LibraryItemPage }))
);

/**
 * Library routes. Reading is `IsSchoolMember` server-side — EVERY role,
 * parents included (backend ADR-018 makes the parent read explicit: school-wide
 * items plus their children's classes). The guard therefore lists all four
 * roles rather than being omitted, so an unknown role is still denied
 * (deny-by-default, FE-ADR-005).
 */
export const libraryRoutes = (
  <Route element={<RequireRole roles={['admin', 'teacher', 'pupil', 'parent']} />}>
    <Route path="/library" element={<LibraryPage />} />
    <Route path="/library/:publicId" element={<LibraryItemPage />} />
  </Route>
);
